import { render, staticRenderFns } from "./detailShow.vue?vue&type=template&id=4d365cf8&scoped=true&"
import script from "./detailShow.vue?vue&type=script&lang=js&"
export * from "./detailShow.vue?vue&type=script&lang=js&"
import style0 from "./detailShow.vue?vue&type=style&index=0&id=4d365cf8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d365cf8",
  null
  
)

export default component.exports